import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useAppDispatch } from "app/hooks";

import CalculationBatch from "components/CalculationBatch";
import SideBarMenu from "components/AucaComponents/SidebarMenu";
import { SideBarElementType } from "components/AucaComponents/SidebarMenu";

import { selectVerticalMenuExpand } from "store/slices/verticalMenuExpand";
import { refresh } from "store/actions/authActions";
import { selectAuthUser } from "store/slices/auth";
import { selectSurveyStatus, selectUserRole, selectUserName } from "store/slices/auth";

import useMediaQuery from "@mui/material/useMediaQuery";
import { Drawer } from "@mui/material";
import { Analytics, BrokenImage, Folder, PhotoCamera, Speed, Savings, Dataset } from "@mui/icons-material";
import json2mq from "json2mq";

import breakpoints from "styles/export.module.scss";
import styles from "./index.module.scss";

const CalculationBatchMenu: React.FC = () => {
  const expand = useSelector(selectVerticalMenuExpand);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const authUserData = useSelector(selectAuthUser);
  const isSurveyCompleted = useSelector(selectSurveyStatus);
  const isLogged = useSelector(selectUserName);
  const userRol = useSelector(selectUserRole)[0];
  const renderPage = useRef(false);

  const menu: SideBarElementType[] = [
    { order: 999, name: "", id: "", icon: "", type: "spacer" },
    { order: 0, name: t("DemoPage.DataInputSection.dataInput"), id: "refProDataInput", icon: <Dataset sx={{ fontSize: 21, color: "#044075" }} />, type: "listElement" },
    { order: 999, name: "", id: "", icon: "", type: "line" },
    { order: 1, name: t("DemoPage.ResultsSection.reference.result"), id: "refProDataInput", icon: <Folder sx={{ fontSize: 17, color: "#007297" }} />, type: "title" },
    { order: 2, name: t("DemoPage.ResultsSection.reference.emission"), id: "refProEmissions", icon: <PhotoCamera sx={{ fontSize: 21, color: "#044075" }} />, type: "listElement" },
    { order: 3, name: t("DemoPage.ResultsSection.reference.indicator"), id: "refProIndicators", icon: <Speed sx={{ fontSize: 21, color: "#044075" }} />, type: "listElement" },
    { order: 4, name: t("DemoPage.ResultsSection.reference.criticPoint"), id: "refProCriticPoints", icon: <BrokenImage sx={{ fontSize: 21, color: "#044075" }} />, type: "listElement" },
    { order: 5, name: t("DemoPage.ResultsSection.reference.resultAnalysis"), id: "refProResultsFinal", icon: <Analytics sx={{ fontSize: 21, color: "#044075" }} />, type: "listElement" },
    { order: 6, name: t("DemoPage.ResultsSection.reference.optimization"), id: "refProOptimization", icon: <Savings sx={{ fontSize: 21, color: "#044075" }} />, type: "listElement" },
    { order: 7, name: t("DemoPage.ResultsSection.reference.download"), id: "refProDownload", icon: <Analytics sx={{ fontSize: 21, color: "#044075" }} />, type: "listElement" },
    { order: 999, name: "", id: "", icon: "", type: "line" },
  ];

  const mobileView = useMediaQuery(
    json2mq({
      minWidth: breakpoints.xlg,
    })
  );

  const getPage = () => {
    return <CalculationBatch />;
  };

  useEffect(() => {
    const plansAccessGrantArray = ["admin", "free_plan", "pro_plan"];

    const validState = () => {
      if (!isLogged) {
        navigate("/login");
      } else if (plansAccessGrantArray.indexOf(userRol) < 0) {
        navigate("/login");
      } else if (!isSurveyCompleted && !(userRol === "company_user") && !(userRol === "company_admin") && !(userRol === "admin")) {
        navigate("/survey");
      }

      if (plansAccessGrantArray.includes(userRol)) {
        renderPage.current = true;
      }
    };

    const onError = () => {
      navigate("/login");
    };

    if (authUserData) {
      dispatch(refresh({ refresh_token: authUserData.refresh_token }, validState, onError));
    } else {
      navigate("/login");
    }

    // eslint-disable-next-line
  }, [navigate, userRol, isLogged, isSurveyCompleted, dispatch]);

  return (
    <div className={styles.container}>
      {renderPage.current && mobileView && (
        <Drawer variant="permanent">
          <div className={styles.sideBar} style={{ width: expand ? "9vw" : "2vw" }}>
            <SideBarMenu menuData={menu} inPageMenu={true} />
          </div>
        </Drawer>
      )}

      <div className={styles.panel} style={{ width: !expand ? "91vw" : "96vw" }}>
        <div className={styles.marginTop} style={{ marginTop: mobileView ? "30px" : "120px" }}>
          {getPage()}
        </div>
      </div>
    </div>
  );
};

export default CalculationBatchMenu;
